// @flow
import { masterCellDataActions } from './masterDataActionCreator';

const initialState = {
  cellPrefixData: {
    isLoading: false,
    isLoaded: true,
    masterCellData: []
  },
  enableDisableShopfloorData: {
    isLoading: false,
    isLoaded: true,
    isShopfloorEnabled: false
  },
  newCellPrefixData: {
    isLoading: false,
    isLoaded: true,
    refreshTab: false,
    cellData: null
  }
};

const masterCellDataReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case masterCellDataActions.GET_MASTER_CELL_DATA: {
      return Object.assign({}, state, { cellPrefixData: action.payload });
    }
    case masterCellDataActions.GET_SHOP_FLOOR_STATUS:
    case masterCellDataActions.ENABLE_DISABLE_SHOPFLOOR: {
      return Object.assign({}, state, {
        enableDisableShopfloorData: action.payload
      });
    }
    case masterCellDataActions.CREATE_UPDATE_CELL_PREFIX:
      return Object.assign({}, state, { newCellPrefixData: action.payload });
    default: {
      return state;
    }
  }
};

export default masterCellDataReducer;
